module.exports = __webpack_public_path__ + "img/work3.69e7f11b.png";